"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MasterarbeitBox = _interopRequireDefault(require("../MasterarbeitBox/MasterarbeitBox"));
var _useBreakPoint = require("../../../common/useBreakPoint");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.masterarbeitList-container .grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-right: -16px; }\n\n@media (max-width: 66rem) {\n  .masterarbeitList-container .grid {\n    grid-template-columns: repeat(2, 1fr); } }\n\n@media (max-width: 42rem) {\n  .masterarbeitList-container .grid {\n    grid-template-columns: repeat(1, 1fr); } }\n";
  const fileName = "MasterarbeitList_MasterarbeitList";
  const element = document.querySelector("style[data-sass-component='MasterarbeitList_MasterarbeitList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MasterarbeitList = _ref => {
  let {
    items,
    lang
  } = _ref;
  const {
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `masterarbeitList-container`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid"
  }, items.map((item, index) => {
    const isLastInRow = isMobile ? false : isTablet ? index % 2 === 1 : index % 4 === 3;
    const isLast = index === items.length - 1;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.id,
      className: `sia-padding-02-right ${!isLastInRow && !isLast && ' sia-border-01-right'}`
    }, /*#__PURE__*/_react.default.createElement(_MasterarbeitBox.default, _extends({}, item, {
      lang: lang
    })));
  })));
};
MasterarbeitList.propTypes = {
  items: _propTypes.default.array
};
MasterarbeitList.defaultProps = {};
var _default = exports.default = MasterarbeitList;